module.exports = __webpack_public_path__ + "static/media/no-results.f22d08d7.svg";